import * as React from "react";
import * as instantMessageChannelService from "../../models/services/instantMessageChannelService";
import { Translations } from "ui/Scripts/source/models/translations";
import { customHistory } from "../../framework/customHistory";
import { Session } from "../../models/session/session";
import { IFrontPageInstantMessageState, IUserState } from "../../models/store/storeTypes";
import { PanelTitle } from "../framework/panelTitle";
import { InstantMessageChannelListLine } from "../instantMessage/instantMessageChannelListLine";
import { AppUtils } from "../../framework/appUtils";
import { IInstantMessageChannelItem, InstantMessageChannelItem } from "ui/Scripts/source/models/instantMessage/instantMessageChannelItem";
import { IInstantMessageListItem } from "ui/Scripts/source/models/instantMessage/instantMessageListItem";
import { InstantMessageChannelList } from "../instantMessage/instantMessageChannelList";
import { SignalRConnectionManager } from "ui/Scripts/source/models/signalR/signalRConnectionManager";
import { FrontPageInfoMessage } from "./frontPageInfoMessage";

//FrontPageInstantMessage
export interface IFrontPageInstantMessageProps {
    user: IUserState;
    state: IFrontPageInstantMessageState;
    loadFrontPageInstantMessage: () => void;
    setLastOpenedInstantMessageChannelId: (id: string) => void;
    setReturnUrl: (url: string) => void;
}
interface IFrontPageInstantMessageViewState {
    channels: InstantMessageChannelItem[];
}

export class FrontPageInstantMessage extends React.Component<IFrontPageInstantMessageProps, IFrontPageInstantMessageViewState> {
    private hasBeenInitialized = false;
    private signalRConnectionManager: SignalRConnectionManager;

    constructor(props: IFrontPageInstantMessageProps) {
        super(props);
        this.state = {
            channels: props.state?.channels ?? []
        };
    }

    componentDidMount(): void {
        //Load front page
        this.props.loadFrontPageInstantMessage();
        this.hasBeenInitialized = true;
        //SignalR
        this.signalRConnectionManager = new SignalRConnectionManager();
        this.signalRConnectionManager.openConnection(appConfig.rootUrl, {
            onUpdateInstantMessageListLine: this.handleInstantMessageUpdated,
            onRemoveInstantMessageChannel: this.handleInstantMessageChannelRemoved,
            onUpdateInstantMessageChannel: this.handleInstantMessageChannelUpdated
        }, Session.getSignalRToken());
    }

    componentWillUnmount(): void {
        this.signalRConnectionManager.closeConnection();
    }

    componentDidUpdate(prevProps: IFrontPageInstantMessageProps, prevState: IFrontPageInstantMessageViewState) {
        const props = this.props;
        const prevChannels = prevProps.state?.channels ?? [];
        const channels = props.state?.channels ?? [];
        if (InstantMessageChannelItem.getHash(prevChannels) === InstantMessageChannelItem.getHash(channels)) return;
        this.setState({
            channels
        });
    }

    // #region SignalR
    handleInstantMessageUpdated = (item: IInstantMessageListItem) => {
        const channels = InstantMessageChannelList.getChannelsAfterInstantMessageUpdated(this.props.user.userCode, this.state.channels, item);
        if (!channels) return;
        this.setState({
            channels
        });
    };

    handleInstantMessageChannelRemoved = (id: string) => {
        const channels = InstantMessageChannelList.getChannelsAfterInstantMessageChannelRemoved(this.state.channels, id);
        if (!channels) return;
        this.setState({
            channels
        });
    };

    handleInstantMessageChannelUpdated = (item: IInstantMessageChannelItem) => {
        const channels = InstantMessageChannelList.getChannelsAfterInstInstantMessageChannelUpdated(this.state.channels, item);
        if (!channels) return;
        this.setState({
            channels
        });
    };
    // #endregion SignalR

    handleInstantMessageLineClick = (id: string) => {
        this.props.setLastOpenedInstantMessageChannelId(id);
        this.props.setReturnUrl("/instantmessage");
        customHistory.push("/instantmessage/" + id);
    };

    handleInvitation = async (instantMessageChannelUserId: string, instantMessageChanneld: string, approve: boolean) => {
        const result = await AppUtils.callService(() => instantMessageChannelService.instantMessageChannelUserInvitationHandle(instantMessageChannelUserId, instantMessageChanneld, approve), false);
        if (!result) return;
        this.props.loadFrontPageInstantMessage();
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <div className="panelContainer">
                <div className="panel instantMassagePanel">
                    <div className="commandRow">
                        <PanelTitle
                            classes="listTitle link"
                            title={Translations.InstantMessagesMenuTitle}
                            onClick={() => customHistory.push("/instantmessage")}
                        />
                        <div className="buttonContainer flexRight">
                            <div className="buttonSpacer"></div>
                        </div>
                    </div>
                    <div className="panelContent listContainer instantMessageChannelListContainer">
                        <div className="lineContainer mainLineContainer instantMessageChannelList">
                            {this.hasBeenInitialized && !props.state?.isLoading && state.channels.length < 1 &&
                                <FrontPageInfoMessage
                                    message={Translations.NoInstantMessageChannelsToShow}
                                />
                            }
                            {state.channels.map((channel) => (
                                <InstantMessageChannelListLine
                                    key={channel.id}
                                    channel={channel}
                                    userCode={props.user?.userCode ?? ""}
                                    selected={false}
                                    first={false}
                                    isLastOpenedInstantMessageChannel={false}
                                    onClick={this.handleInstantMessageLineClick}
                                    onLongPress={null}
                                    onRefreshList={null}
                                    onHandleInvitation={this.handleInvitation}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}